export default __webpack_public_path__ + "static/media/drawer_nw.e87bbfb7.svg";